import React from "react";
import { Link } from "react-router-dom";
import { Button, Card } from "../components/ui";
import { MarqueeColumn, Pic } from "../components/lux";
import { imageById } from "../assets/characterImages";

const FEATURES = [
  { icon: "🎭", title: "ตัวละครให้เลือกคุย", text: "ตั้งแต่เพื่อนร่วมชั้นสดใส ไปจนถึงนักดูดาวช่างเล่า" },
  { icon: "✍️", title: "สร้างตัวละครของคุณเอง", text: "กำหนดนิสัย คำทักทาย และบทบาท แล้วแชร์ให้เพื่อน" },
  { icon: "🌍", title: "จักรวาลหลายตัวละคร", text: "โลกเดียวกัน หลายตัวละคร เรื่องราวต่อเนื่อง" },
  { icon: "🎁", title: "เช็คอินรับคอยน์ฟรี", text: "รับคอยน์ทุกวัน แล้วใช้คุยได้ทันที" },
];

// คอลัมน์ collage ในฮีโร่ (เลือกภาพสวยหลากโทน)
const COLS = [
  ["07", "393", "63", "423", "124", "412"],
  ["373", "14", "432", "37", "384", "186"],
  ["394", "123", "435", "62", "416", "402"],
].map((ids) => ids.map(imageById).filter(Boolean));

// ตัวละครเด่น — แสดงเป็น "แนวเรื่อง" (ไม่ใช่ชื่อตัวละครจริงในระบบ)
const SPOTLIGHT = [
  { id: "07", genre: "ราชสำนัก", text: "ขุนนางผู้สง่างาม กับกฎมารยาทสุดแปลก" },
  { id: "373", genre: "แฟนตาซี", text: "ผู้ปกครองดินแดนน้ำแข็งที่ใจอบอุ่นกว่าที่คิด" },
  { id: "394", genre: "ตำนานโบราณ", text: "เรื่องเล่าจากวังทองที่ไม่มีใครเคยได้ยิน" },
  { id: "04", genre: "ลึกลับ", text: "เงามืดที่ปากร้ายแต่ชวนชงชาเสมอ" },
  { id: "233", genre: "โรแมนติก", text: "วันสบาย ๆ ใต้ต้นซากุระกับคนที่ฟังคุณเสมอ" },
];

export default function Landing() {
  const spot = SPOTLIGHT.map((x) => ({ ...x, img: imageById(x.id) })).filter((x) => x.img);
  const cta = imageById("432");
  return (
    <div className="public lux-landing" style={{ minHeight: "100vh" }}>
      <div className="public__bar">
        <Link to="/" className="brand"><span className="brand__logo">💬</span>AITalk</Link>
        <Link className="btn btn--sm btn--ghost" to="/login">เข้าสู่ระบบ</Link>
      </div>
      <section className="lux-hero">
        <div className="lux-hero__copy">
          <span className="lux-eyebrow"><i aria-hidden="true" />เพื่อนคุยที่พร้อมฟังคุณทุกเวลา</span>
          <h1 className="lux-title">คุยกับ <span>ตัวละคร AI</span><br />ได้ทุกเวลา</h1>
          <p>สร้างตัวละคร คุยกับ AI และสำรวจโลกแห่งจินตนาการไร้ขีดจำกัด — เริ่มต้นฟรี พร้อมคอยน์ต้อนรับ</p>
          <div className="row wrap lux-hero__cta">
            <Link to="/register"><Button variant="primary" size="lg">คุยเลย</Button></Link>
            <Link to="/login"><Button variant="ghost" size="lg">เข้าสู่ระบบ</Button></Link>
          </div>
          <ul className="lux-hero__stats" aria-label="จุดเด่น">
            <li><b>หลายแนว</b><span>โรแมนติก แฟนตาซี</span></li>
            <li><b>ฟรี</b><span>คอยน์ต้อนรับ</span></li>
            <li><b>24/7</b><span>คุยได้ทุกเวลา</span></li>
          </ul>
        </div>
        <div className="lux-hero__collage" aria-hidden="true">
          {COLS.map((items, k) => <MarqueeColumn key={k} items={items} reverse={k === 1} speed={64 + k * 10} className={`lux-col--${k + 1}`} />)}
        </div>
      </section>

      <section className="lux-section" aria-labelledby="lux-spot">
        <div className="lux-section__head">
          <span className="lux-eyebrow">ตัวละครเด่น</span>
          <h2 id="lux-spot" className="lux-title lux-title--sm">เลือกคุยได้ทุกแนวที่ใช่</h2>
        </div>
        <div className="lux-spot">
          {spot.map((x, i) => (
            <Link to="/register" key={x.id} className="lux-spot__card" aria-label={`${x.genre} — เริ่มคุย`}>
              <Pic img={x.img} size="med" eager={i < 2} className="lux-spot__img" />
              <span className="lux-spot__shade" />
              <span className="lux-spot__cap"><b>{x.genre}</b><span>{x.text}</span></span>
            </Link>
          ))}
        </div>
      </section>

      <div className="feature-grid lux-features">
        {FEATURES.map((f) => (
          <Card key={f.title} glass>
            <div className="feature__icon" aria-hidden="true">{f.icon}</div>
            <h3 className="mt-8">{f.title}</h3>
            <p className="muted mt-8">{f.text}</p>
          </Card>
        ))}
      </div>

      <section className="lux-cta">
        <Pic img={cta} size="med" className="lux-cta__bg" />
        <div className="lux-cta__shade" />
        <div className="lux-cta__body">
          <h2 className="lux-title lux-title--sm">พร้อมเจอเพื่อนคุยคนใหม่แล้วหรือยัง</h2>
          <p>สมัครฟรี รับคอยน์ต้อนรับ แล้วเริ่มบทสนทนาแรกได้ทันที</p>
          <Link to="/register"><Button variant="primary" size="lg">สมัครและเริ่มคุย</Button></Link>
        </div>
      </section>
      <footer className="center faint" style={{ padding: 24, fontSize: 13 }}>
        ตัวละครและบทสนทนาทั้งหมดเป็นเรื่องแต่ง · <Link to="/terms">ข้อกำหนดและความเป็นส่วนตัว</Link>
      </footer>
    </div>
  );
}
